import { FinancialTable as Component } from './components/FinancialTable';
import Connector from './connector';

export const FinancialTableV2 = (props: any) => <Connector {...props} component={Component} />;
